module.exports = __webpack_public_path__ + "static/media/football-carousel-2-640x360.31abea65.jpg";